import { Component, OnInit, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {FormControl} from '@angular/forms';
//import { ActivatedRoute}  from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Inject} from '@angular/core';

export interface DialogData {
  animal: string;
  name: string;
}
// declare var tinymce: any;

const longText = `Mega Man X, known in Japan as Rockman X,[a] is an action-platform video game developed and published by Capcom for the Super Nintendo Entertainment System (SNES).
  1
  2
  3`;

@Component({
  selector: 'app-editar-norm35',
  templateUrl: './editar-norm35.component.html',
  styleUrls: ['./editar-norm35.component.scss']
})
export class EditarNorm35Component implements OnInit {

  fieldArray: Array<any> = [];
  newAttribute: any = {};
  // Second prueba
  fieldArrayTask: Array<any> = [];
  newAttributeTask: any = {};

  // Formulario Firts
  str: any;
  NewDescripcion: any;
  Taskfecha: any;
  nombreResponsableTmp: any;
  cargoResponsableTmp: any;
  animal: string;
  name: string;
  idTareaTmp: any;
  tareasTmpFirts: any;
  IdtaskTmpFirtsSave: any;
  pathTmp:any;

  // Fin second 
  addFieldValue() {
    this.fieldArray.push(this.newAttribute)
    this.newAttribute = {};
  }
  deleteFieldValue(index) {
    this.fieldArray.splice(index, 1);
  }

  addFieldValueTask(idSeccionTmp,nombreSeccionTmp) {
    // tareasTmpFirts
    this.fieldArrayTask.push(this.newAttribute)
    this.newAttributeTask = {};
    this.taskDate = this.serializedDate.value;
    let i=0;
    let nombreLinkTmp: any;
    let rutaTmp: any;
    for(i=0; i<this.infoNom35.length; i++){
      if(nombreSeccionTmp == this.infoNom35[i].tittle){
        nombreLinkTmp = this.infoNom35[i].tittle;
        rutaTmp = this.infoNom35[i].ruta;
      }
    }
    this.dataTask = {
        idSeccion : idSeccionTmp,
        fechaDocumentador: 2019,
        fechaTarea: " " ,
        descripcion: " " ,
        nombreResponsable: " ",
        cargoResponsable: " ",
        nombreLink:nombreLinkTmp,
        ruta: rutaTmp,
        estatus: 1,
    }; 
    this.idiomasService.saveTask(this.dataTask).subscribe( (data : any) => {
      this.tareasTmpFirts=data.tarea;
      this.IdtaskTmpFirtsSave=this.tareasTmpFirts._id;
    });
  }

  deleteFieldValueTask(index) {
    this.fieldArrayTask.splice(index, 1);
  }

  deleteFieldValueTaskFull(index,TaskArray,idTable,idTask) {
    TaskArray.splice(index,1);
    this.dataTask = {
      idSeccion : idTable,
      idTarea: idTask,
      fechaDocumentador: 2019,
    };
    this.idiomasService.deleteTask(this.dataTask).subscribe((data:any) => {
    });
  }
 
  date = new FormControl(new Date());
  serializedDate = new FormControl((new Date()).toISOString());

  panelOpenState = false;
  // INICIO DE AUTISZE
  public longText = longText;
  public minRows = 1;
  public maxRows = 2;
  public onlyGrow = true;
  public useImportant = true;

  dataTask: any;
  data: {id: any};
  dataId : any ;
  todoForm: FormGroup;
  createMode: boolean = true;
  IDseccionTmp: any ;
  taskOnly: any;

  
  constructor(private formBuilder: FormBuilder,
    private activated: ActivatedRoute,
    private idiomasService: IdiomasServiceN35,
    public dialog: MatDialog) {
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      width: '600px',
      data: {name: this.name, animal: this.animal}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.animal = result;
    });
  }

  title = 'angulartinymc';
  tittleTmpTable : any;
  InfoTabla: any;
  editor: any;
  fly=0;

 
  
  ngOnInit() {
    this.data = {
      id: this.activated.snapshot.params.id
    };
    this.activated.data.subscribe  (params=>{this.dataId = params});
    this.tittleTmpTable=this.getInfoTable(this.data.id);
    this.InfoTabla = this.sendInfoTable(this.tittleTmpTable);
    this.todoForm = this.formBuilder.group({
      description: ['', Validators.required],
      done: false
    });
    this.getPath(this.data.id);
    console.log(this.tittleTmpTable);
    this.seccionIdtmp = this.sendInfoTableIDSeccion(this.tittleTmpTable);
  }
  typeEvent: any;
  DataTmp: any;
  fechaDocumentador_P : any;
  idSeccionTmp : any;
  nombreSeccionTmp :any;
  requerimientoTmp :any;
  instruccion1Tmp :any;
  implementacionTmp :any;
  duenioTmp :any;
  frecuenciaRevisionTmp :any;
  instruccion2Tmp :any;
  evidenciaCumplimientoTmp :any;
  seccionIdtmp: any;
  eventTmp: any;
  ListTasktmp: any;
  TaskListtmp: any; 
  
  private getInfoTable(idData){
    let i = 0 ; 
    let posTmp : any;
    let tittleTmp: any;
    for( i=0; i < this.infoNom35.length;i++){
      if(this.infoNom35[i].position == idData){
        tittleTmp = this.infoNom35[i].tittle;
      }
    }
    return tittleTmp;
  }
  private sendInfoTable(tittle){
    this.fechaDocumentador_P = 2019;
    let Objtamanio: any;
    let i:0;
    this.idiomasService.getStepsData(this.fechaDocumentador_P).subscribe(( data:any )=>{

      if(data.message=="Success"){
          for(i=0; i<data.secciones.length; i++){
            if(data.secciones[i].nombreSeccion==tittle){
              this.idSeccionTmp = data.secciones[i]._id;
              this.nombreSeccionTmp = data.secciones[i].nombreSeccion;
              this.ListTasktmp = data.secciones[i].tareas;

              this.dataTask = {
                idSeccion : this.idSeccionTmp,
                fechaDocumentador: 2019,
              };
                this.idiomasService.getTaskOnly(this.dataTask).subscribe((dataS:any)=>{
                this.TaskListtmp = dataS.tareas;
                console.log(this.TaskListtmp);
              });
            }
          }
      }
    });

  }

  private sendInfoTableIDSeccion(tittle){
    this.fechaDocumentador_P = 2019;
    let i:0;
    let id: any;
    this.idiomasService.getStepsData(this.fechaDocumentador_P).subscribe(( data:any )=>{
      if(data.message=="Success"){
          for(i=0; i<data.secciones.length; i++){
            if(data.secciones[i].nombreSeccion==tittle){
              id=data.secciones[i]._id;
            }
          }
      }
    });
    
  }
  

  private onActTaskPerson(event,idTable, idTask){
    console.log(this.serializedDate.value);
    let fecha = new Date();
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
    }else{
      this.dataTask = {
        idSeccion : idTable,
        idTarea: idTask,
        fechaDocumentador: "2019",
        nombreResponsable: this.typeEvent,
        estatus: 1,
      }; 
      this.idiomasService.saveTask(this.dataTask).subscribe( (data : any) => {
        console.log(data);
      });
    }
  }

  private onActTaskCargo(event,idTable, idTask){
    
    let fecha = new Date();
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
    }else{
      this.dataTask = {
        idSeccion : idTable,
        idTarea: idTask,
        fechaDocumentador: "2019",
        cargoResponsable: this.typeEvent,
        estatus: 1,
      }; 
      this.idiomasService.saveTask(this.dataTask).subscribe( (data : any) => {
        console.log(data);
      });
    }
  }

  private onActTaskDescription(event,idTable, idTask){
    let fecha = new Date();
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
    }else{
      this.dataTask = {
        idSeccion : idTable,
        idTarea: idTask,
        fechaDocumentador: 2019,
        descripcion: this.typeEvent,
        estatus: 1,
      }; 
      this.idiomasService.saveTask(this.dataTask).subscribe( (data : any) => {
        console.log(data);
      });
    }
  }

  myFunction(event){ 
    if(event.keyCode == 191) { 
      
      console.log("Dude");
    } 
  }
  private onKeyDownHandler(event) {
    console.log("Entro");

    var codigo = event.which || event.keyCode;

    console.log("Presionada: " + codigo);
     
    if(codigo === 13){
      console.log("Tecla ENTER");
    }

    if(codigo >= 65 && codigo <= 90){
      console.log(String.fromCharCode(codigo));
    }

     
}

  private onDateTask(event,idTable, idTask){
    let fechaDatepicker: any;
    fechaDatepicker=this.serializedDate.value;
    this.typeEvent = event.target.value;
  
    if(this.typeEvent.length == 0 ){
    }else{
      this.dataTask = {
        idSeccion : idTable,
        idTarea: idTask,
        fechaDocumentador: 2019,
        fechaTarea: this.typeEvent,
      }; 
      this.idiomasService.saveTask(this.dataTask).subscribe( (data : any) => {
        console.log(data);
      });
    }
  }

  private onNameask(event,idTable, idTask){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
    }else{
      this.dataTask = {
        idSeccion : idTable,
        idTarea: idTask,
        fechaDocumentador: 2019,
        nombreResponsable: this.typeEvent,
      }; 
      this.idiomasService.saveTask(this.dataTask).subscribe( (data : any) => {
      });
    }
  }
  private linkTask(idTable,idTask,taskRuta,taskTitle){
    this.dataTask = {
      idSeccion : idTable,
      idTarea: idTask,
      fechaDocumentador: 2019,
      nombreLink: taskTitle,
      ruta: taskRuta,
    };
    this.idiomasService.saveTask(this.dataTask).subscribe( (data : any) => {
    });
  }
  taskDate: any;

  private getPath(id){
    let i=0;
    for(i=0; i<this.infoNom35.length; i++){
      if(id == this.infoNom35[i].position){
        this.pathTmp=this.infoNom35[i].ruta;  
      }
    }
  }

 

  

  infoNom35 = [
    {
      position: 52, 
      tittle: "5.2 Identificar y analizar los factores de riesgo psicosocial",
      ruta : '/step5-sub2',
    },{
      position: 53, 
      tittle: "5.3 Identificar y analizar los factores de riesgo psicosocial",
      ruta : '/step5-sub3',
    },{
      position: 54, 
      tittle : "5.4 Adoptar las medidas para prevenir y controlar los factores de riesgo psicosocial",
      ruta : '/step5-sub4',
    },{
      position: 55,
      tittle: "5.5 Identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos",
      ruta : '/step5-sub5',
    },{
      position: 56,
      tittle: "5.6 Practicar exámenes médicos y evaluaciones psicológicas",
      ruta : '/step5-sub6',
    },{
      position: "51a",
      tittle: "5.1 a) La prevención de los factores de riesgo psicosocial",
      ruta : '/step5-sub1-a%29',
    },{
      position: "51b",
      tittle: "5.1 b) La prevención de la violencia laboral",
      ruta : '/step5-sub1-b%29',
    },{
      position: "51c",
      tittle: "5.1 c) La promoción de un entorno organizacional favorable",
      ruta : '/step5-sub1-c%29',
    },{
      position: "57a",
      tittle: "5.7 a) La política de prevención de riesgos psicosociales",
      ruta : '/step7-sub1-a%29',
    },{
      position: "57b",
      tittle: "5.7 b) Las medidas adoptadas para combatir las prácticas opuestas",
      ruta : '/step7-sub1-b%29',
    },{
      position: "57c",
      tittle: "5.7 c) Las medidas y acciones de prevención y, en su caso, las acciones ...",
      ruta : '/step7-sub1-c%29',
    },{
      position: "57d",
      tittle: "5.7 d) Los mecanismos para presentar quejas por prácticas opuesta ",
      ruta : '/step7-sub1-d%29',
    },{
      position: "57e",
      tittle: "5.7 e) Los resultados de la identificación y análisis de los factores",
      ruta : '/step7-sub1-e%29',
    },{
      position: "57f",
      tittle: "5.7 f) Las posibles alteraciones a la salud por la exposición a los factores de riesgo",
      ruta : '/step7-sub1-f%29',
    },{
      position: "58a",
      tittle: "5.8 a) Los resultados de la identificación y análisis de los factores de riesgo psicosocia",
      ruta: "/step8-sub8-a%29",
    },{
      position: "58b",
      tittle: "5.8 b) Las medidas de control adoptadas cuando el resultado de la identificación",
      ruta: "/step8-sub8-b%29",
    },{
      position: "58c",
      tittle: "5.8 c) Los nombres de los trabajadores a los que se les practicaron los exámenes",
      ruta: "/step8-sub8-c%29",
    },{
      position: 6, 
      tittle: "6. Obligaciones de los trabajadores",
      ruta: "",

    },{
      position: 61, 
      tittle: '6.1 Observar las medidas de prevención...',
      ruta: "/step6-sub1",
    },{
      position: 62, 
      tittle: '6.2 Abstenerse de realizar prácticas...',
      ruta: "/step6-sub2",
    },{
      position: 63, 
      tittle: '6.3 Participar en la identificación de...',
      ruta: "/step6-sub3",
    },{
      position: 64, 
      tittle: '6.4 Informar sobre prácticas opuestas...',
      ruta: "/step6-sub4",

    },{
      position: 65, 
      tittle: '6.5 Informar por escrito al patrón directamente...',
      ruta: "/step6-sub5",
    },{
      position: 66, 
      tittle: '6.6 Participar en los eventos...',
      ruta: "/step6-sub6",
    },{
      position: 67, 
      tittle: '6.7 Someterse a los exámenes médicos y evaluaciones...',
      ruta: "/step6-sub7",
    },{ /////////////////////THIS IS STEPS´S 7 BEGINING
      position: 75, 
      tittle:"7.5 Los cuestionarios que desarrolle ...",
      ruta : '/step7-sub5',
    },{
      position: 76,
      tittle:"7.6 La identificación y análisis de...",
      ruta : '/step7-sub6',
    },{
      position: 77,
      tittle:"7.7 El resultado de la identificación...",
      ruta : '/step7-sub7',
    },{
      position: 78,
      tittle:"7.8 El resultado de la identificación...",
      ruta : '/step7-sub8',
    },{
      position: 79,
      tittle:"7.9 La identificación y análisis...",
      ruta : '/step7-sub9',
    },{
      position: "71a",
      tittle: "7.1 a) Los centros de trabajo que tengan entre 16 y 50 trabajadores,",
      ruta : '/step7-sub1-a%29'
    },{
      position: "71b",
      tittle: "7.2 b) Las cargas de trabajo",
      ruta : '/step7-sub1-b%29'
    },{ // INICIO SUBINDICE 72
      position: "72a",
      tittle: "7.2 a) La identificación y análisis de los factores de riesgo psicosocial deberá contemplar lo siguiente:",
      ruta:'/step7-sub2-a%29'
    },{
      position: "72b",
      tittle: "7.2 b) Las cargas de trabajo",
      ruta:'/step7-sub2-b%29'
    },{
      position: "72c",
      tittle: "7.2 c) La falta de control sobre el trabajo",
      ruta:'./step7-sub2-c%29'
    },{
      position: "72d",
      tittle : '7.2 d) Las jornadas de trabajo y rotación de turnos que exceden lo establecido en la Ley Federal del Trabajo',
      ruta:'/step7-sub2-d%29'
    },{
      position: "72e",
      tittle: "'7.2 e) Interferencia en la relación trabajo-familia',",
      ruta:'/step7-sub2-e%29'
    },{
      position: "72f",
      tittle: "7.2 f) Liderazgo negativo y relaciones negativas en el trabajo",
      ruta:'/step7-sub2-f%29'
    },{
      position: "72g",
      tittle: "7.2 g) La violencia laboral",
      ruta:'/step7-sub2-g%29'
    },{ // FIN 72 SUBINDICE
      position: "74a",
      tittle: "7.4 a) La aplicación de cuestionarios que cumplan con lo dispuesto por los numerales 7.2 y/o 7.3",
      ruta : '/step7-sub4-a%29'
    },{
      position: "74b",
      tittle: "7.4 b) La forma como se deberá realizar la aplicación de los cuestionarios",
      ruta : '/step7-sub4-b%29'
    },{
      position: "74c",
      tittle: "7.4 c) La manera de evaluar los cuestionarios",
      ruta : '/step7-sub4-c%29'
    },{
      position: "74d",
      tittle: "7.4 d) Los niveles de riesgo y la forma de determinarlos conforme a los resultados de los cuestionarios",
      ruta : '/step7-sub4-d%29'
    },///////////////////////////// THIS PART IS THE STEP'S 7 END
    {
      position: 83,
      tittle: "8.3 Los centros de trabajo...",
      ruta : '/step8-sub1-c)'
    },{
      position: 84,
      tittle: "8.4 El Programa para la atención...",
      ruta : '/step8-sub4'
    },{
      position: "81a",
      tittle: "8.1 a) Establecer acciones para la prevención de los factores de riesgo psicosocial que impulsen ",
      ruta : '/step8-sub1-a%29'
    },{
      position: "81b",
      tittle: "8.1 b) Disponer de mecanismos seguros y confidenciales para la recepción de quejas",
      ruta : '/step8-sub1-b%29'
    },{
      position: "81c",
      tittle: "8.1 c) Realizar acciones que promuevan el sentido de pertenencia de los trabajadores a la organización",
      ruta : '/step8-sub1-c%29'
    },{
      position: "85a",
      tittle: "8.5 a) El tipo de acciones deberán realizarse, según aplique, en los niveles siguientes:",
      ruta : '/step8-sub5-c%29'
    },{
      position: "85b",
      tittle: "8.5 b) Segundo nivel",
      ruta : '/step8-sub5-b%29'
    },{
      position: "85c",
      tittle: "8.5 c) Tercer nivel",
      ruta : '/step8-sub5-c%29'
    }, // Inicio de sección 9
    {
      position: 91, 
      tittle:"9.1 El patrón tendrá la opción de contratar",
      ruta : '/step9-sub1',
    },{
      position: 92, 
      tittle:"9.2 Las unidades de verificación que evalúen",
      ruta : '/step9-sub1',
    },{
      position: 93, 
      tittle:"9.3 Las unidades de verificación",
      ruta : '/step9-sub1',
    },{
      position: 94, 
      tittle: "9.4 La vigencia de los dictámenes emitidos por las unidades de verificación será de dos años",
      ruta : '/step9-sub1',
    }, // Fin de seccion 9
    {
      position: 101, 
      tittle: "10.1 Este procedimiento para la evaluación...",
      ruta : '/step10-sub1'
    },{
      position: 102, 
      tittle: "10.2 Los aspectos a verificar durante...",
      ruta : '/step10-sub2'
    },{
      position: 103, 
      tittle: "10.3 Para la selección de trabajadore...",
      ruta : '/step10-sub3'
    },{
      position: 104, 
      tittle: "10.4 Las evidencias de tipo...",
      ruta : '/step10-sub3'
    },
 
    {
      position: 11,
      tittle: "Documentos de Soporte",
      ruta: "",
    },{
      position: 111,
      tittle: "Guía de referencia II: Identificación y análisis de los factores de riesgo psicosocial",
      ruta: "",
    },{
      position: 112,
      tittle: "Guía de Referencia III: Identificación y análisis de los factores de riesgo psicosocial y evaluación del entorno organizacional en los centros de trabajo",
      ruta: "",
    },{
      position: 12,
      tittle: "Objetivo, Campo de aplicación y Referencias",
      ruta: "",

    },{
      position: 121,
      tittle: "",
      ruta: "",
 
    },{
      position: 122,
      tittle: "",
      ruta: "",

    },{
      position: 123,
      tittle: "",
      ruta: "",
  
    }
    
  ]

}

@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'dialog-overview-example-dialog.html',
})
export class DialogOverviewExampleDialog {
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}
